import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleCampaignsMetricsItemFragment on ModuleCampaignsMetricsItem {
    title
    subtitle
    metricsItemDescription: description
  }
`
